import {
  File,
  supportedDocExtensions,
  SupportedFileTypes,
  supportedImageFileExtensions,
  supportedPdfExtensions,
  supportedPPTExtensions,
  supportedTextLogExtensions,
  supportedVideoFileExtensions,
  supportedXlsExtensions,
  supportedZipExtensions,
} from "../models";

export const mapFilesToAttachmentUrls = (files: File[]): string[] => {
  return files.map((file) => file.url).filter((url) => !!url) as string[];
};

export const resolveFileType = (name?: string | null) => {
  if (!name) return;

  const fileExtension = resolveFileExtensionFromName(name);

  if (!fileExtension) return;

  if (supportedImageFileExtensions.includes(fileExtension)) {
    return SupportedFileTypes.IMAGE;
  }
  if (supportedVideoFileExtensions.includes(fileExtension)) {
    return SupportedFileTypes.VIDEO;
  }
  if (supportedTextLogExtensions.includes(fileExtension)) {
    return SupportedFileTypes.TXT;
  }
  if (supportedZipExtensions.includes(fileExtension)) {
    return SupportedFileTypes.ZIP;
  }
  if (supportedDocExtensions.includes(fileExtension)) {
    return SupportedFileTypes.DOC;
  }
  if (supportedPPTExtensions.includes(fileExtension)) {
    return SupportedFileTypes.PPT;
  }
  if (supportedPdfExtensions.includes(fileExtension)) {
    return SupportedFileTypes.PDF;
  }
  if (supportedXlsExtensions.includes(fileExtension)) {
    return SupportedFileTypes.XLS;
  }
};

export const resolveFileExtensionFromName = (url: string) => {
  const dotIndex = url.lastIndexOf(".");

  if (dotIndex === -1) return;

  return url.substring(dotIndex);
};

// export const getImageOrientationFromUrl = (url: string): Promise<"landscape" | "portrait"> => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//
//     img.crossOrigin = "anonymous";
//
//     img.onload = () => {
//       const orientation = img.width >= img.height ? "landscape" : "portrait";
//       resolve(orientation);
//     };
//
//     img.onerror = (err) => {
//       reject(err);
//     };
//
//     img.src = url;
//   });
// };
//
// export async function getVideoOrientationFromUrl(url: string): Promise<"landscape" | "portrait"> {
//   return new Promise((resolve, reject) => {
//     const video = document.createElement("video");
//
//     // Needed for remote videos with CORS
//     video.crossOrigin = "anonymous";
//
//     // Only load metadata to get dimensions
//     video.onloadedmetadata = () => {
//       const orientation = video.videoWidth >= video.videoHeight ? "landscape" : "portrait";
//       resolve(orientation);
//     };
//
//     video.onerror = (err) => {
//       reject(new Error("Failed to load video"));
//     };
//
//     video.src = url;
//   });
// }
